
export const styleSheet = () => ({
    "@global": {
      ".auth-app-bar .MuiToolbar-root": {
        "backgroundColor": "white !important"
      },
 
    }
  })